module.exports = __webpack_public_path__ + "img/multiple_schedule.48e86cd9.png";